// src/components/scan/ConfirmationModal.tsx
import { XCircle, CheckCircle } from 'lucide-react';
import React from 'react';

interface ConfirmationModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  t: (key: string) => string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  message,
  onConfirm,
  onCancel,
  t,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div
        className="
          bg-gray-900 border-2 border-blue-700 rounded-xl 
          p-4 sm:p-8 shadow-xl w-full max-w-xs sm:max-w-lg 
          transform transition-all scale-100 text-white
        "
      >
        {/* Icono + título */}
        <div className="flex items-center gap-2 sm:gap-3">
          <XCircle className="text-red-500 w-8 h-8 sm:w-12 sm:h-12" />
          <h2 className="text-lg sm:text-2xl font-bold">
            {t('scan.confirmation')}
          </h2>
        </div>

        {/* Mensaje */}
        <p className="text-gray-300 text-sm sm:text-lg mt-4">
          {message}
        </p>

        {/* Botones */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-4 mt-6">
          <button
            onClick={onCancel}
            className="
              px-4 py-2 sm:px-6 sm:py-2 
              text-sm sm:text-base text-white 
              bg-gray-700 rounded-lg hover:bg-gray-600 
              transition-all
            "
          >
            {t('scan.no')}
          </button>
          <button
            onClick={onConfirm}
            className="
              px-4 py-2 sm:px-6 sm:py-2 
              sm:text-lg bg-gradient-to-r from-red-500 to-red-700 
              hover:from-red-600 hover:to-red-800 
              rounded-lg flex items-center justify-center 
              gap-1 sm:gap-2 transition-all text-white 
              shadow-md shadow-red-900
            "
          >
            <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6" />
            <span>{t('scan.yes')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
